/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */
import { getCollectionReference } from 'services'
import { collectionNames } from 'constant'

export const getSolanaNFtCollections = ({ limit, orderRef, order }: any) => {
  return new Promise((resolve, reject) => {
    try {
      const results: any = []
      const collections: any = []

      /** Create a ref collection for invalid magic eden slug */
      const invalidMagicEdenSlugRef = getCollectionReference(
        collectionNames.INVALID_MAGIC_EDEN_SLUG,
      )

      /** Create a ref collection for top collections */
      const topCollectionsRef = getCollectionReference(collectionNames.TOP_COLLECTIONS)

      invalidMagicEdenSlugRef
        .limit(limit + Number(10))
        .orderBy(orderRef, order)
        .get()
        .then(async (instance) => {
          if (instance.size > 0) {
            instance.forEach((collection: any) => {
              const invalidMagicEdenData = collection.data()
              results.push({
                invalid_magic_eden_slug_id: collection.id,
                invalid_magic_eden_slug: invalidMagicEdenData.slug,
                invalid_magic_eden_slug_created_at: invalidMagicEdenData.created_at,
              })
            })

            for (const result of results) {
              const query = await topCollectionsRef
                .where('slug', '==', result.invalid_magic_eden_slug.replaceAll('_', '-'))
                .get()

              if (!query.empty) {
                const snapshot = query.docs[0]
                const topCollectionData = snapshot.data()

                if (topCollectionData.active == true) {
                  collections.push({
                    ...result,
                    ...topCollectionData,
                    top_collection_id: snapshot.id,
                    status:
                      result.invalid_magic_eden_slug === topCollectionData.magic_eden_slug
                        ? false
                        : true,
                    opensea_link: `https://opensea.io/collection/${topCollectionData.slug}`,
                  })
                }
              }
            }

            resolve({
              collection: collections,
              limit: limit + Number(40),
              hasDataToLoad: true,
            })
          } else {
            resolve({
              collection: collections,
              limit: limit + Number(40),
              hasDataToLoad: false,
            })
          }
        })
    } catch (error) {
      console.log('getSolanaNFtCollections | error', error)
      reject(error)
    }
  })
}

export const updateMagicEdenSlug = (slug: string, collection: any) => {
  return new Promise((resolve, reject) => {
    try {
      const {
        top_collection_id,
        invalid_magic_eden_slug,
        invalid_magic_eden_slug_id,
        invalid_magic_eden_slug_created_at,
        ...topCollectionsData
      } = collection

      console.log('invalid_magic_eden_slug', invalid_magic_eden_slug)
      console.log('invalid_magic_eden_slug_id', invalid_magic_eden_slug_id)
      console.log('invalid_magic_eden_slug_created_at', invalid_magic_eden_slug_created_at)

      const topCollectionsRef = getCollectionReference(collectionNames.TOP_COLLECTIONS)

      topCollectionsRef.doc(top_collection_id).update({
        ...topCollectionsData,
        magic_eden_slug: slug,
      })

      resolve({ success: true, slug, collection })
    } catch (error) {
      console.log('getSolanaNFtCollections | error', error)
      reject(error)
    }
  })
}

export const deleteMagicEdenSlug = ({ id }: any) => {
  return new Promise((resolve, reject) => {
    try {
      /** Create a ref collection for invalid magic eden slug */
      const invalidMagicEdenSlugRef = getCollectionReference(
        collectionNames.INVALID_MAGIC_EDEN_SLUG,
      )

      invalidMagicEdenSlugRef.doc(id).delete()

      resolve({ success: true, id })
    } catch (error) {
      console.log('deleteMagicEdenSlug | error', error)
      reject(error)
    }
  })
}

export const setCollectionInactive = (collection: any) => {
  return new Promise((resolve, reject) => {
    try {
      /** Create a ref collection for invalid magic eden slug */
      const topCollectionsRef = getCollectionReference(collectionNames.TOP_COLLECTIONS)

      if (collection.active) {
        topCollectionsRef.doc(collection.id).update({ active: false })
        collection.active = false
        resolve({ success: true, slug: collection.slug, collection })
        return
      } else {
        topCollectionsRef.doc(collection.id).update({ active: true })
        collection.active = true
        resolve({ success: true, slug: collection.slug, collection })
        return
      }
    } catch (error) {
      console.log('setCollectionInactive | error', error)
      reject(error)
    }
  })
}

export const setCollectionInactiveDuplicateMeSlugs = (id: string) => {
  try {
    /** Create a ref collection for invalid magic eden slug */
    const topCollectionsRef = getCollectionReference(collectionNames.TOP_COLLECTIONS)
    topCollectionsRef.doc(id).update({ active: false })
  } catch (error) {
    console.log('setCollectionInactiveDuplicateMeSlugs | error', error)
  }
}
